import React, { Component } from 'react';

export default class PromoBlock extends Component {
  render() {
    return (
      <div className="promo-block">
        <div className="container">
          <div className="row">
            <div className="col-md-8 col-md-offset-2 text-center">
              <h2>Cloudinary is your A to Z image management solution - upload, storage, administration, manipulation, optimization and delivery.</h2>
              <a href="https://cloudinary.com/signup?source=demo" className="btn btn-default">Sign up for free</a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/js/components/PromoBlock.js
 **/